import React from "react";
import { NavLink } from "react-router-dom";
import { linkConfig } from "../../router";
import { isPad, isJ18 } from "../../assets";
import classNames from "classnames";
import styles from "./index.module.scss";

console.log(isPad, isJ18);
export default function Homepage() {
  return (
    <div className={isPad ? styles.pad_homepage : styles.homepage}>
      {isPad || isJ18 || <header>日程同步帮助</header>}
      {linkConfig.map((ele) => (
        <div
          key={ele.title}
          className={classNames(styles.block, { [styles.isJ18]: isJ18 })}
        >
          <p className={styles.title}>{ele.title}</p>
          {ele.lists.map((value, index) => (
            <li className={styles.navLink} key={value.desc}>
              {ele.lists.length === 1 ? "" : `${index + 1}.`}
              <NavLink exact to={value.path}>
                {value.desc}
              </NavLink>
            </li>
          ))}
        </div>
      ))}
    </div>
  );
}
